import { STARTING_SCORES } from "./scoring";
import type { SessionProgress } from "./types";

export const STORAGE_KEY = "oratrice.progress.v1";

interface ProgressStore {
  version: 1;
  sessions: Record<string, SessionProgress>;
}

const EMPTY_STORE: ProgressStore = { version: 1, sessions: {} };

function readStore(): ProgressStore {
  if (typeof window === "undefined") return EMPTY_STORE;
  try {
    const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) ?? "null") as Partial<ProgressStore> | null;
    if (value?.version !== 1 || !value.sessions || typeof value.sessions !== "object") return EMPTY_STORE;
    return { version: 1, sessions: value.sessions };
  } catch {
    return EMPTY_STORE;
  }
}

function writeStore(store: ProgressStore): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    // Storage can be unavailable in private or locked-down browser contexts.
  }
}

export function loadSession(scenarioId: string): SessionProgress | null {
  return readStore().sessions[scenarioId] ?? null;
}

export function saveSession(session: SessionProgress): void {
  const store = readStore();
  writeStore({ ...store, sessions: { ...store.sessions, [session.scenarioId]: session } });
}

export function freshSession(scenarioId: string, firstRoundId: string): SessionProgress {
  return {
    scenarioId,
    roundId: firstRoundId,
    scores: { ...STARTING_SCORES },
    completed: false,
  };
}

export function clearProgress(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing else is required when storage is unavailable.
  }
}
